import { useState, useEffect } from "react";
import api from "./api";

// Identidade da empresa logada (nome, logo, cidade, site).
// Cada empresa preenche a sua em Configuracoes. Nada aqui e fixo de nenhuma marca.
let cache = null;

function doLocal() {
  let c = {}, e = {};
  try { c = JSON.parse(localStorage.getItem("crm_config") || "{}") || {}; } catch (x) {}
  try { e = JSON.parse(localStorage.getItem("crm_empresa") || "{}") || {}; } catch (x) {}
  return {
    nome:   String(c.nome   || e.nome || "").trim(),
    logo:   String(c.logo   || "").trim(),
    cidade: String(c.cidade || "").trim(),
    site:   String(c.site   || "").trim(),
    slogan: String(c.slogan || "").trim(),
  };
}

// Leitura imediata (para telas). Usa o que ja esta guardado no navegador.
export function marcaSync() { return cache || doLocal(); }

// Busca no servidor e guarda. Barato depois da primeira vez.
export async function marca(forcar) {
  if (forcar) { cache = null; try { localStorage.removeItem("crm_config"); } catch (x) {} }
  if (cache && !forcar) return cache;
  try {
    const { data } = await api.get("/empresa");
    if (data) { try { localStorage.setItem("crm_config", JSON.stringify(data)); } catch (x) {} }
  } catch (e) {}
  cache = doLocal();
  return cache;
}

export function limparMarca() {
  cache = null;
  try { localStorage.removeItem("crm_config"); } catch (x) {}
}

export function guardarMarca(c) {
  try { localStorage.setItem("crm_config", JSON.stringify(c || {})); } catch (x) {}
  cache = null;
}

// Nome em caixa alta para o cabecalho dos PDFs.
export function nomePdf(m) { return String((m && m.nome) || "").toUpperCase(); }
